import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

export const generateAgoraToken = async (channelName, uid = null, role = 'publisher') => {
  try {
    const generateToken = httpsCallable(functions, 'generateAgoraToken');
    const result = await generateToken({
      channelName,
      uid,
      role,
      expirationTimeInSeconds: 3600 // 1 hour
    });
    
    return result.data;
  } catch (error) {
    console.error('Error generating Agora token:', error);
    throw error;
  }
};

// Helper function to generate a unique channel name for a session
export const getChannelName = (sessionId) => {
  return `session_${sessionId}`;
};

// Helper function to generate a unique user ID
export const getUserId = (userId) => {
  // Convert Firebase UID to a numeric value for Agora
  // This is a simple hash function - you might want to use a more robust solution
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    const char = userId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
};